import { aomGraphqlRequest } from 'core/utils/backend-service';
import {
    TrainingRegistrationMappingData,
    TrainingRegistrationMappingDataAPI,
    mapTrainingRegistrationMappingDataFromAPIToModel,
} from '../types/lms-training-registration-mapping.type';
import {
    TrainingRegistration,
    mapTrainingRegistrationFromAPIToModel,
    mapTrainingRegistrationFromModelToAPI,
} from '../types/lms-training-registration.type';
import {
    applyLearningCourses,
    createCourseMappings as createCourseMappingsMutation,
    getCourseMapping,
    getLearningCourses,
} from './lms-api-integration.queries';

export const getExistingTrainingRegistrations = (): Promise<Array<TrainingRegistration>> =>
    aomGraphqlRequest(getLearningCourses()).then((response) =>
        mapTrainingRegistrationFromAPIToModel(response.data.learningCourses)
    );

export const applyTrainingRegistrations = (learningCourses: TrainingRegistration[]): Promise<{ result: string }> =>
    aomGraphqlRequest(applyLearningCourses(), { courses: mapTrainingRegistrationFromModelToAPI(learningCourses) }).then(
        () => ({
            result: 'ok',
        })
    );

export const getExistingTrainingRegistrationMapping = (): Promise<TrainingRegistrationMappingData | undefined> =>
    aomGraphqlRequest(getCourseMapping()).then((response) =>
        response.data.courseMapping
            ? mapTrainingRegistrationMappingDataFromAPIToModel(response.data.courseMapping)
            : undefined
    );

export const createCourseMappings = (courseMapping: TrainingRegistrationMappingDataAPI) =>
    aomGraphqlRequest(createCourseMappingsMutation(), { mapping: courseMapping }).then(() => ({
        result: 'ok',
    }));
